"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var Disposal32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M29.087 15.604c.315-.02.457.226.501.445.005 6.938-5.741 12.541-12.679 12.546-4.148.027-7.946-2.026-10.39-5.269l.055 2.5c.045.219-.226.457-.445.501-.316.02-.457-.226-.502-.445l-.034-3.736c-.045-.219.226-.457.445-.502l3.736-.034c.316-.019.457.226.502.445.045.22-.226.457-.445.502l-2.693.003c2.154 3.166 5.785 5.07 9.714 5.088 6.526-.012 11.756-5.236 11.815-11.639-.044-.219.2-.36.42-.405zm-.96-10.714c.315-.019.457.226.502.445l.034 3.737c.045.219-.226.457-.445.502l-3.736.034c-.316.019-.458-.226-.502-.445-.045-.22.226-.457.445-.502l2.692-.003c-2.154-3.166-5.785-5.07-9.714-5.088-6.622-.014-11.852 5.21-11.911 11.613.044.219-.226.457-.445.502-.316.019-.458-.226-.502-.445C4.54 8.302 10.286 2.698 17.224 2.694c4.148-.028 7.946 2.025 10.39 5.268l-.055-2.499c.078-.29.349-.528.568-.573z", fillRule: "evenodd", clipRule: "evenodd" }))); };
var StyledDisposal32 = styled_components_1.default(Disposal32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledDisposal32;
var templateObject_1;
//# sourceMappingURL=Disposal32.js.map